function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { Fragment, useState, useContext, useEffect, useCallback, useRef } from "react";
import { Popper } from "../../Popper";
import { NavigationButton } from "../NavigationButton/index";
import { Tooltip } from "../../Tooltip";
import ThemeContext from "../../ThemeProvider/ThemeContext";
import AppSwitcherIcon from "../../Icon/AppSwitcher";
import { useBreakpoints } from "../../Breakpoints/BreakpointsProvider";
import useStyle from "./AppSwitcher.style";
var useOnClickOutside = function(param) {
    var popperRef = param.popperRef, handleClose = param.handleClose, menuOpen = param.menuOpen;
    useEffect(function() {
        var listener = function(event) {
            if (menuOpen && (!popperRef.current || _instanceof(event.target, Node) && popperRef.current.contains(event.target))) {
                return;
            }
            if (menuOpen && handleClose) {
                handleClose();
            }
        };
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);
        return function() {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    });
};
export var AppSwitcher = function(param) {
    var accessibilityLabel = param.accessibilityLabel, children = param.children, _isDefaultOpen = param.isDefaultOpen, isDefaultOpen = _isDefaultOpen === void 0 ? false : _isDefaultOpen, _isRtl = param.isRtl, isRtl = _isRtl === void 0 ? false : _isRtl, onClose = param.onClose, _popperjsModifiers = param.popperjsModifiers, popperjsModifiers = _popperjsModifiers === void 0 ? [] : _popperjsModifiers, testID = param.testID;
    var ref = _slicedToArray(useState(isDefaultOpen), 2), menuOpen = ref[0], setMenuOpen = ref[1];
    var popperRef = useRef(null);
    var triggerRef = useRef(null);
    var breakpoints = useBreakpoints();
    var ref1 = useStyle({
        isRtl: isRtl,
        breakpoints: breakpoints
    }), containerStyles = ref1.containerStyles, menuStyles = ref1.menuStyles;
    var theme = useContext(ThemeContext);
    var handleTargetClick = function() {
        setMenuOpen(!menuOpen);
        if (menuOpen) {
            handleClose();
        }
    };
    var handleClose = useCallback(function() {
        setMenuOpen(false);
        if (onClose) {
            onClose();
        }
    }, [
        onClose
    ]);
    useOnClickOutside({
        popperRef: popperRef,
        handleClose: handleClose,
        menuOpen: menuOpen
    });
    return _jsxs(Fragment, {
        children: [
            _jsx("div", {
                css: containerStyles,
                ref: triggerRef,
                children: _jsx(Tooltip, {
                    text: accessibilityLabel,
                    trigger: function(openTooltip, closeTooltip, forwardedRef) {
                        return _jsx(NavigationButton, {
                            accessibilityLabel: accessibilityLabel,
                            "aria-expanded": menuOpen,
                            "aria-haspopup": true,
                            forwardedRef: forwardedRef,
                            icon: function() {
                                return _jsx(AppSwitcherIcon, {
                                    size: "m",
                                    color: theme.font.color.fill
                                });
                            },
                            isPill: true,
                            onBlur: !menuOpen ? closeTooltip : undefined,
                            onClick: function() {
                                handleTargetClick();
                                closeTooltip();
                            },
                            onFocus: !menuOpen ? openTooltip : undefined,
                            onMouseOut: !menuOpen ? closeTooltip : undefined,
                            onMouseOver: !menuOpen ? openTooltip : undefined,
                            testID: testID
                        });
                    }
                })
            }),
            _jsx(Popper, {
                flip: true,
                isOpen: menuOpen,
                isRtl: isRtl,
                placement: 'bottom-end',
                popperjsModifiers: [
                    {
                        name: 'offset',
                        enabled: false
                    }
                ].concat(_toConsumableArray(popperjsModifiers)),
                popperRef: popperRef,
                triggerRef: triggerRef,
                children: _jsx("div", {
                    "aria-label": accessibilityLabel,
                    css: menuStyles,
                    children: _jsx("ul", {
                        children: children(handleClose)
                    })
                })
            })
        ]
    });
};
export default AppSwitcher;
